module.exports = __webpack_public_path__ + "static/img/bin.95b8b32e.png";